import css from '../../../utils/css';

export default css`
  [class*='_ValueBetWrapper_'] {
    --fox-background: #000;
    --fox-black: #1c1c1c;
    --fox-dark-gray: #333333;
    --fox-light-gray: #e5e5e5;
    --fox-background-gray: #b2b2b2;
    --fox-player-props-gray: #919191;
    --fox-white: #ffffff;

    background-color: var(--fox-dark-gray);

    div[class*='_valueBetMainContainer_'] {
      background-color: var(--fox-dark-gray) !important;
    }

    div[class*='_eventInfoContainer_'] {
      color: var(--fox-white) !important;
    }

    [class^='_projectedIcon_'] {
      background-color: var(--fox-background-gray) !important;
      color: var(--fox-background);
    }

    [class*='_noBestBets_'] {
      color: var(--fox-light-gray);
      border-color: var(--fox-background);
    }

    [class*='_eventHeaderContainer_'] {
      background-color: var(--fox-background);
    }

    [class^='_recommendedTeamContainer_'] {
      border-color: var(--fox-black);
    }

    [class^='_recommendedTeamContainer_'] thead,
    [class^='_mobileRecommended_'] thead,
    [class^='_recommendedTeamContainer_'] [class^='_tooltipText_'],
    [class^='_mobileRecommended_'] [class^='_tooltipText_'],
    [class*='_playerTable_'] [class^='_tooltipText_'],
    [class*='_eventExpandContainer_'],
    [class*='_playerTable_'] thead {
      background-color: var(--fox-dark-gray);
    }

    [class*='_playerTable_'] td,
    [class*='_playerTable_'] tr {
      border-color: var(--fox-dark-gray);
    }

    div[class*='_playerPropLabel_'] {
      background-color: var(--fox-background);
      color: var(--fox-white) !important;
    }

    [class^='_recommendedTeamContainer_'] thead *,
    [class^='_mobileRecommended_'] thead *,
    [class*='_playerTable_'] thead * {
      color: var(--fox-light-gray);
    }

    [class*='_eventExpandContainer_'] p,
    [class*='_eventExpandContainer_'] div {
      color: var(--fox-light-gray);
      opacity: 100% !important;
    }

    [class*='_eventExpandContainer_']:hover {
      background-color: var(--fox-dark-gray);
      opacity: 95% !important;
    }

    [class*='_eventExpandContainer_']:hover div {
      background-color: var(--fox-dark-gray);
    }

    [class^='_mobileRecommended_'] tbody *,
    [class*='_playerTable_'] tbody *,
    [class^='_recommendedTeamContainer_'] tbody * {
      background-color: var(--fox-black);
    }

    [class^='_mobileRecommended_'] tbody td,
    [class*='_playerTable_'] tbody td,
    [class^='_recommendedTeamContainer_'] tbody td {
      color: var(--fox-white);
    }

    [class*='_playerTable_'] [class*='_playerInfo_'] {
      color: var(--fox-player-props-gray);
    }

    [class*='_bestBetContainer_'] {
      border-radius: 6px;
    }
    [class*='_bestBetContainer_'] a {
      color: var(--fox-background) !important;
    }

    [class*='_bestBetContainer_'] *:not(img) {
      background-color: var(--fox-light-gray) !important;
    }

    [class*='_starsContainer_'] [class*='_starIcon_'][data-active='true'] {
      fill: var(--fox-white) !important;
    }

    [class*='_starsContainer_'] [class*='_starIcon_'][data-active='false'] {
      fill: var(--fox-dark-gray) !important;
    }

    /* neccessary because there is an opacity animation which is causing a 'white flash' effect */
    @keyframes dropInNoOpacity {
      0% {
        transform: translateY(-2%);
        opacity: 1;
      }
      100% {
        transform: translateY(0);
        opacity: 1;
      }
    }

    [class*='_dropIn_'] {
      -webkit-animation: dropInNoOpacity 0.2s cubic-bezier(0, 0.85, 0.95, 1)
        forwards !important;
      -moz-animation: dropInNoOpacity 0.2s cubic-bezier(0, 0.85, 0.95, 1)
        forwards !important;
      -ms-animation: dropInNoOpacity 0.2s cubic-bezier(0, 0.85, 0.95, 1)
        forwards !important;
      -o-animation: dropInNoOpacity 0.2s cubic-bezier(0, 0.85, 0.95, 1) forwards !important;
      animation: dropInNoOpacity 0.2s cubic-bezier(0, 0.85, 0.95, 1) forwards !important;
    }
  }
`;
